import React, { useRef } from "react"

import { ScrivitoPageBreadcrumb } from "scrivito/scrivito-breadcrumb/ScrivitoPageBreadcrumb"
import { useElementHeight } from "shared/lib/css/useElementHeight"

import { useProductPageContext } from "../context/ProductPageContext"

export const ProductPageBreadcrumb = React.memo(() => {
  const { productObj } = useProductPageContext()
  const ref = useRef<HTMLDivElement>(null)
  useElementHeight(ref, { variableName: "breadcrumb-height" })

  return (
    <div ref={ref} className="product-page__breadcrumb">
      <ScrivitoPageBreadcrumb page={productObj} />
    </div>
  )
})
